/* eslint-disable @typescript-eslint/no-require-imports */
import type React from "react";

import type { PageLayoutProps } from "$src/core/components/templates/PageLayout/types";
import CustomPlatform from "$src/core/utils/platform/platform";

export default CustomPlatform.select<() => React.FC<PageLayoutProps>>({
  web: () => require("./PageLayout.web").default,
  default: () => require("./PageLayout").default,
})();
